import { TranslateService } from '@ngx-translate/core';
import { Component, ViewChild } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { ConfigurationTicketsListPage } from "../../configuration-tickets/configuration-tickets-list/configuration-tickets-list";
import { HttpClient } from '@angular/common/http';
import { getCurrencySymbol, DatePipe } from '@angular/common';
import { PrintServices } from '../../../services/printServices';
import * as moment from 'moment';
import { TpvCashInoutCreatePage } from '../../../tpv/tpv-cash-inout-create/tpv-cash-inout-create';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';
import { AnalyticsPage } from '../../../analytics/analytics';
import { PopupWaiterReportSales } from '../../../components/popups/popup-waiter-report-sales/popup-waiter-report-sales';
import { AdvancedAnalyticsServices } from '../../../analytics/advanced-analytics-services';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { ConfigurationCloseCashCreate } from '../configuration-close-cash-create/configuration-close-cash-create';
import { ConfigurationCloseCashList } from '../configuration-close-cash-list/configuration-close-cash-list';
import { CustomersListPage } from '../../../customers/customers-list/customers-list';
import { ConfigurationTicketsRatingsListPage } from '../../configuration-tickets/configuration-tickets-ratings-list/configuration-tickets-ratings-list';
/**
 * Generated class for the ConfigurationCloseCashViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-close-cash-view',
  templateUrl: 'configuration-close-cash-view.html',
})
export class ConfigurationCloseCashViewPage {
  //vars
  date_first: any;
  date_last: any;
  uid_cash: string = 'all';
  cashs: any;
  cash_uid: string = 'all';
  opened_page: string = '';
  activeTab: string = 'tickets';
  //loader vars
  loader_totals: boolean = true;
  loader_report_totals: boolean = true;
  loader_payment_type: boolean = true;
  loader_tickets_list: boolean = true;
  loader_tickets_canceled_list: boolean = true;
  loader_history_cash: boolean = true;
  loader_history_close_cash: boolean = true;
  loader_top_elements_sold: boolean = true;
  loader_sales_type: boolean = true;
  loader_waiters_work_list: boolean = true;
  loader_discounts_type: boolean = true;
  loader_deliveries_type: boolean = true;
  loader_top_categories: boolean = true;
  loader_report_foodcost: boolean = true;
  // Variables para cálculo de ahorro de deliveries
  // Bloque verde: Ahorro actual (Recogida + Domicilio)
  own_deliveries_total: number = 0;
  own_deliveries_savings: number = 0;
  // Bloque rojo: Ahorro potencial (plataformas intermediarias)
  platforms_deliveries_total: number = 0;
  platforms_deliveries_savings: number = 0;
  // Variables legacy (mantener para compatibilidad)
  deliveries_total: number = 0;
  deliveries_with_commission: number = 0;
  deliveries_savings: number = 0;
  deliveries_savings_percentage: number = 0;
  //charts
  public chartPaymentTypeLabels: any;
  public chartPaymentTypeData: any;
  public chartPaymentTypeType: any;
  public chartPaymentTypeOptions: any;
  public chartPaymentTypeColors: any;

  public chartDiscountLabels: any;
  public chartDiscountData: any;
  public chartDiscountType: any;
  public chartDiscountOptions: any;
  public chartDiscountColors: any;

  public chartTopElementsLabels: any;
  public chartTopElementsData: any;
  public chartTopElementsType: any;
  public chartTopElementsOptions: any;
  public chartTopElementsColors: any;

  public chartTopCategoriesLabels: any;
  public chartTopCategoriesData: any;
  public chartTopCategoriesType: any;
  public chartTopCategoriesOptions: any;
  public chartTopCategoriesColors: any;

  public chartTypeTicketLabels: any;
  public chartTypeTicketData: any;
  public chartTypeTicketType: any;
  public chartTypeTicketOptions: any;
  public chartTypeTicketcolors: any;

  public foodcost_0_element: any;
  public tickets_searchbar_text = "";

  //datatable
  sorts = [
    { prop: 'number', dir: 'asc' },
    { prop: 'date', dir: 'asc' },
    { prop: 'cash_static', dir: 'asc' },
    { prop: 'type', dir: 'asc' },
    { prop: 'payment_type', dir: 'asc' },
    { prop: 'amount', dir: 'asc' }
  ];

  sorts_inout = [
    { prop: 'cash', dir: 'asc' },
    { prop: 'type', dir: 'asc' },
    { prop: 'date_final', dir: 'asc' },
    { prop: 'concept', dir: 'asc' },
    { prop: 'amount', dir: 'asc' }
  ];

  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public configurationServices: ConfigurationServices,
    private http: HttpClient,
    private printServices: PrintServices,
    public datepipe: DatePipe,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    public advancedAnalyticsServices: AdvancedAnalyticsServices) {

    this.globals.GAtrackView('Sales', 'Sales - Close cash history - List', this.globals.restaurant.email, 'View', 'Close cash history', 'Sales', '');

    //init necessary vars
    this.date_first = moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss');
    this.date_last = moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss');
    this.advancedAnalyticsServices.limit_date1 = '';
    this.advancedAnalyticsServices.limit_date2 = '';
    this.uid_cash = 'all';
    this.configurationServices.biclosecash_cash_name = this.translate.instant('general-todos');
    //call fun
    this.initGetAllDataOfCloseCash();
  }

  // #region INIT

  async ionViewWillEnter() {
    if (this.opened_page == 'entrada_salida_caja') {
      this.opened_page = ''
    }
  }
  async initGetAllDataOfCloseCash() {
    await this.getCashs();
    this.getAllDataOfCloseCash();
  }

  async getAllDataOfCloseCash() {
    //clean vars
    this.cleanBiclosecashVars();

    // First check for duplicated tickets
    await this.checkDuplicatedTickets();

    //required
    this.getTotals();
    this.getReportTotals();
    this.getPaymentType();
    this.getTicketsList();
    this.getTicketsCanceled();
    this.getTopElementsSold();
    this.getTopCategoriesSold();
    this.getSalesType();
    this.getRatings();
    //required para arqueo
    this.getHistoryCashOrCashs();
    this.getHistoryCloseCash();
    //pro
    if ((this.globals.checkLimitsByLicense('sales', 'close_cash') == 'basic plus' || this.globals.checkLimitsByLicense('sales', 'close_cash') == 'full')) {
      this.getDiscountsType();
      this.getDeliveriesType();
    }
    if (this.globals.checkLimitsByLicense('analytics', 'analytics')) {
      this.getWaitersWorkList();
      this.getFoodcost();
    }
  }

  // New method to check for duplicated tickets
  async checkDuplicatedTickets(): Promise<boolean> {
    try {
      const response: any = await this.http.post(this.globals.analytics_path + 'biclosecash/check_duplicated_tickets', {
        public_key: this.globals.public_key,
        uid_cash: this.cash_uid,
        datetime_init: new Date(this.date_first),
        datetime_final: new Date(this.date_last),
      }).toPromise();
      return !response.success;
    } catch (error) {
      return true;
    }
  }

  // #region FUNCIONES DE NODE

  //funcion que devuelve los totales
  async getTotals() {
    await this.http.post(this.globals.analytics_path + 'biclosecash/get_totals', {
      public_key: this.globals.public_key,
      uid_cash: this.cash_uid,
      datetime_init: new Date(this.date_first),
      datetime_final: new Date(this.date_last),
    }, {}).subscribe(async data => {
      this.configurationServices.biclosecash_total = data['total'];
      this.configurationServices.biclosecash_total_notax = data['total_notax'];
      this.configurationServices.biclosecash_total_tax = data['total_tax'];
      this.configurationServices.biclosecash_total_tips = data['total_tips'];
      this.configurationServices.biclosecash_total_with_tips = data['total_with_tips'];
      this.configurationServices.biclosecash_total_taxes = data['total_taxes'];
      this.loader_totals = false;
    },
      err => {
        this.loader_totals = false;
      });
  }

  async getReportTotals() {
    await this.http.post(this.globals.analytics_path + 'analytics/daily_report_totals', {
      public_key: this.globals.public_key,
      uid_cash: this.cash_uid,
      first_date: new Date(this.date_first),
      last_date: new Date(this.date_last),
    }, {}).subscribe(async data => {
      this.configurationServices.biclosecash_avg_ticket = data['avg'];
      this.configurationServices.biclosecash_persons_served = data['persons_served'];
      this.configurationServices.biclosecash_avg_person_served = data['avg_person_served'];
      this.configurationServices.biclosecash_customers_attended = data['customers_attended'];
      this.configurationServices.biclosecash_ticket_sale_max = data['ticket_sale_max'];
      this.configurationServices.biclosecash_ticket_sale_min = data['ticket_sale_min'];
      this.configurationServices.biclosecash_tickets_without_person = data['tickets_without_person'];

      this.loader_report_totals = false;
    },
      err => {
        this.loader_report_totals = false;
      });
  }

  //funcion que devuelve top elementos vendidos
  async getTopElementsSold() {
    await this.http.post(this.globals.analytics_path + 'biclosecash/get_top_elements_sold', {
      public_key: this.globals.public_key,
      uid_cash: this.cash_uid,
      datetime_init: new Date(this.date_first),
      datetime_final: new Date(this.date_last),
    }, {}).subscribe(async data => {
      this.initChartTopElementSold(data);
    },
      err => {
        this.loader_top_elements_sold = false;
      });
  }

  //funcion que devuelve top elementos vendidos
  async getTopCategoriesSold() {
    await this.http.post(this.globals.analytics_path + 'analytics/daily_report_elements', {
      public_key: this.globals.public_key,
      uid_cash: this.cash_uid,
      first_date: new Date(this.date_first),
      last_date: new Date(this.date_last),
    }, {}).subscribe(async data => {
      this.initChartTopCategoriesSold(data['data_categories']);
    },
      err => {
        this.loader_top_categories = false;
      });
  }

  //funcion que devuelve los totales por tipo de sitio de venta (mesa bar delivery)
  async getSalesType() {
    await this.http.post(this.globals.analytics_path + 'biclosecash/get_sales_type', {
      public_key: this.globals.public_key,
      uid_cash: this.cash_uid,
      datetime_init: new Date(this.date_first),
      datetime_final: new Date(this.date_last),
    }, {}).subscribe(async data => {
      //rellenamos las variables
      this.configurationServices.biclosecash_sales_type_name = data['sales_type_name'];
      this.configurationServices.biclosecash_sales_type_amount = data['sales_type_amount'];
      this.initChartTicketType(data);
      this.loader_sales_type = false;
    },
      err => {
        this.loader_sales_type = false;
      });
  }

  //funcion que devuelve los totales por tipo de venta (cash card notspecified)
  async getPaymentType() {
    await this.http.post(this.globals.analytics_path + 'biclosecash/get_payment_type', {
      public_key: this.globals.public_key,
      uid_cash: this.cash_uid,
      datetime_init: new Date(this.date_first),
      datetime_final: new Date(this.date_last),
    }, {}).subscribe(async data => {
      //normal
      this.configurationServices.biclosecash_total_cash = data['total_cash'];
      this.configurationServices.biclosecash_total_card = data['total_card'];
      this.configurationServices.biclosecash_total_stripe = data['total_stripe'];
      this.configurationServices.biclosecash_total_paypal = data['total_paypal'];
      this.configurationServices.biclosecash_total_payplaza = data['total_payplaza'];
      this.configurationServices.biclosecash_total_crypto = data['total_crypto'];
      this.configurationServices.biclosecash_total_verifone = data['total_verifone'];
      this.configurationServices.biclosecash_total_not_specified = data['total_not_specified'];
      this.configurationServices.biclosecash_total_redsys = data['total_redsys'];
      this.configurationServices.biclosecash_total_getnet = data['total_getnet'];
      this.configurationServices.biclosecash_total_comerciaglobalpay = data['total_comerciaglobalpay'];
      this.configurationServices.biclosecash_total_bank_transfer = data['total_bank_transfer'];
      this.configurationServices.biclosecash_total_american_express = data['total_american_express'];
      this.configurationServices.biclosecash_total_bizum = data['total_bizum'];
      this.configurationServices.biclosecash_total_online = data['total_online'];
      this.configurationServices.biclosecash_total_bank_draft = data['total_bank_draft'];
      this.configurationServices.biclosecash_total_cryptocurrencies = data['total_cryptocurrencies'];
      this.configurationServices.biclosecash_total_ticket_restaurant = data['total_ticket_restaurant'];
      //crypto
      this.configurationServices.biclosecash_total_btc = data['total_btc'];
      this.configurationServices.biclosecash_total_bch = data['total_bch'];
      this.configurationServices.biclosecash_total_dai = data['total_dai'];
      this.configurationServices.biclosecash_total_doge = data['total_doge'];
      this.configurationServices.biclosecash_total_eth = data['total_eth'];
      this.configurationServices.biclosecash_total_ltc = data['total_ltc'];
      this.configurationServices.biclosecash_total_usdc = data['total_usdc'];
      //tip
      this.configurationServices.biclosecash_tip_cash = data['tip_cash'];
      this.configurationServices.biclosecash_tip_card = data['tip_card'];
      this.configurationServices.biclosecash_tip_stripe = data['tip_stripe'];
      this.configurationServices.biclosecash_tip_paypal = data['tip_paypal'];
      this.configurationServices.biclosecash_tip_payplaza = data['tip_payplaza'];
      this.configurationServices.biclosecash_tip_verifone = data['tip_verifone'];
      this.configurationServices.biclosecash_tip_not_specified = data['tip_not_specified'];
      this.configurationServices.biclosecash_tip_redsys = data['tip_redsys'];
      this.configurationServices.biclosecash_tip_getnet = data['tip_getnet'];
      this.configurationServices.biclosecash_tip_comerciaglobalpay = data['tip_comerciaglobalpay'];
      this.configurationServices.biclosecash_tip_bank_transfer = data['tip_bank_transfer'];
      this.configurationServices.biclosecash_tip_american_express = data['tip_american_express'];
      this.configurationServices.biclosecash_tip_bizum = data['tip_bizum'];
      this.configurationServices.biclosecash_tip_online = data['tip_online'];
      this.configurationServices.biclosecash_tip_bank_draft = data['tip_bank_draft'];
      this.configurationServices.biclosecash_tip_cryptocurrencies = data['tip_cryptocurrencies'];
      this.configurationServices.biclosecash_tip_ticket_restaurant = data['tip_ticket_restaurant'];
      //calculate tpv, online and others
      this.calculateTpvMethods(data);
      this.calculateOnlineMethods(data);
      this.calculateOthers(data);
      //
      this.initChartPaymentType(data);
      this.calculateArqueo();
      this.loader_payment_type = false;
    },
      err => {
        this.loader_payment_type = false;
      });
  }

  calculateTpvMethods(data) {
    var total = 0;
    total += parseFloat(data['total_getnet']) || 0;
    total += parseFloat(data['total_comerciaglobalpay']) || 0;
    total += parseFloat(data['total_payplaza']) || 0;
    this.configurationServices.biclosecash_total_tpv = total;
  }

  calculateOnlineMethods(data) {
    var total = 0;
    total += parseFloat(data['total_stripe']) || 0;
    total += parseFloat(data['total_paypal']) || 0;
    total += parseFloat(data['total_redsys']) || 0;
    this.configurationServices.biclosecash_total_online_methods = total;
  }

  calculateOthers(data) {
    var total = 0;
    total += parseFloat(data['total_bank_transfer']) || 0;
    total += parseFloat(data['total_american_express']) || 0;
    total += parseFloat(data['total_bizum']) || 0;
    total += parseFloat(data['total_online']) || 0;
    total += parseFloat(data['total_bank_draft']) || 0;
    total += parseFloat(data['total_cryptocurrencies']) || 0;
    total += parseFloat(data['total_ticket_restaurant']) || 0;
    total += parseFloat(data['total_not_specified']) || 0;
    this.configurationServices.biclosecash_total_others = total;
  }

  //funcion que devuelve el listado de las acciones del camarero
  async getWaitersWorkList() {
    await this.http.post(this.globals.analytics_path + 'biclosecash/get_waiters_work_list', {
      public_key: this.globals.public_key,
      uid_cash: this.cash_uid,
      datetime_init: new Date(this.date_first),
      datetime_final: new Date(this.date_last),
    }, {}).subscribe(async data => {
      this.configurationServices.biclosecash_waiters = data['waiters'];
      this.loader_waiters_work_list = false;
    },
      err => {
        this.loader_waiters_work_list = false;
      });
  }

  //funcion que devuelve el listado de tickets
  async getTicketsList() {
    this.loader_tickets_list = true;
    await this.http.post(this.globals.analytics_path + 'biclosecash/get_tickets_list', {
      public_key: this.globals.public_key,
      uid_cash: this.cash_uid,
      datetime_init: new Date(this.date_first),
      datetime_final: new Date(this.date_last),
    }, {}).subscribe(async data => {
      this.configurationServices.biclosecash_tickets = data['tickets'];
      this.configurationServices.biclosecash_tickets_array_tmp = Array.from(data['tickets']);
      this.configurationServices.biclosecash_tickets_filtered = this.configurationServices.biclosecash_tickets_array_tmp;
      this.configurationServices.biclosecash_list_tickets_array = this.configurationServices.biclosecash_tickets_array_tmp;
      this.configurationServices.biclosecash_total_tips = data['total_tips'];
      this.loader_tickets_list = false;
    },
      err => {
        this.loader_tickets_list = false;
      });
  }

  //funcion que devuelve los descuentos y sus totales
  async getDiscountsType() {
    await this.http.post(this.globals.analytics_path + 'biclosecash/get_discounts_type', {
      public_key: this.globals.public_key,
      uid_cash: this.cash_uid,
      datetime_init: new Date(this.date_first),
      datetime_final: new Date(this.date_last),
    }, {}).subscribe(async data => {
      //
      this.configurationServices.biclosecash_total_discount = this.globals.round2decimal(data['total_discount'])
      this.configurationServices.biclosecash_total_invite = this.globals.round2decimal(data['total_invite'])
      this.configurationServices.biclosecash_total_restaurant_ticket = this.globals.round2decimal(data['total_restaurant_ticket'])
      this.configurationServices.biclosecash_total_line_discount = this.globals.round2decimal(data['total_line_discount'])
      //
      this.initChartDiscountType(data);
      this.configurationServices.biclosecash_total_discounted = data['total_discounted'];
      this.loader_discounts_type = false;
    },
      err => {
        this.loader_discounts_type = false;
      });
  }

  //funcion que devuelve el historico de la caja (movimientos salida entrada efectivo)
  async getHistoryCashOrCashs() {
    await this.http.post(this.globals.analytics_path + 'biclosecash/get_history_cash_or_cashs', {
      public_key: this.globals.public_key,
      uid_cash: this.cash_uid,
      datetime_init: new Date(this.date_first),
      datetime_final: new Date(this.date_last),
    }, {}).subscribe(async data => {
      this.configurationServices.biclosecash_history = data['history'];
      this.changeStringToDate();
      this.calculateArqueo();
      this.loader_history_cash = false;
    },
      err => {
        this.loader_history_cash = false;
      });
  }

  async getHistoryCloseCash() {
    await this.http.post(this.globals.analytics_path + 'biclosecash/get_history_close_cash', {
      public_key: this.globals.public_key,
      uid_cash: this.cash_uid,
      datetime_init: new Date(this.date_first),
      datetime_final: new Date(this.date_last),
    }, {}).subscribe(async data => {
      this.configurationServices.biclosecash_history_close_cash = data['history'];
      this.loader_history_close_cash = false;
    },
      err => {
        this.loader_history_close_cash = false;
      });
  }

  //funcion que devuelve los tipos de deliveries usados y sus totales
  async getDeliveriesType() {
    await this.http.post(this.globals.analytics_path + 'biclosecash/get_deliveries_type', {
      public_key: this.globals.public_key,
      uid_cash: this.cash_uid,
      datetime_init: new Date(this.date_first),
      datetime_final: new Date(this.date_last),
    }, {}).subscribe(async data => {
      this.configurationServices.biclosecash_deliveries = data['deliveries'];
      this.loader_deliveries_type = false;
      // Calcular ahorro de deliveries (todos excepto Recogida y Domicilio)
      this.calculateDeliveriesSavings();
    },
      err => {
        this.loader_deliveries_type = false;
        this.own_deliveries_total = 0;
        this.own_deliveries_savings = 0;
        this.platforms_deliveries_total = 0;
        this.platforms_deliveries_savings = 0;
        this.deliveries_total = 0;
        this.deliveries_with_commission = 0;
        this.deliveries_savings = 0;
        this.deliveries_savings_percentage = 0;
      });
  }

  // Función que calcula el ahorro separando deliveries propios y de plataformas
  calculateDeliveriesSavings() {
    if (!this.configurationServices.biclosecash_deliveries || this.configurationServices.biclosecash_deliveries.length === 0) {
      // Resetear todos los valores
      this.own_deliveries_total = 0;
      this.own_deliveries_savings = 0;
      this.platforms_deliveries_total = 0;
      this.platforms_deliveries_savings = 0;
      this.deliveries_total = 0;
      this.deliveries_with_commission = 0;
      this.deliveries_savings = 0;
      this.deliveries_savings_percentage = 0;
      return;
    }

    const commissionRate = 0.25; // 25% de comisión

    // Separar deliveries propios (Recogida y Domicilio) y de plataformas
    const ownDeliveryNames = ['recogida', 'domicilio'];
    const ownDeliveries = this.configurationServices.biclosecash_deliveries.filter(d => {
      if (!d.name) return false;
      const normalizedName = d.name.toLowerCase().trim();
      return ownDeliveryNames.includes(normalizedName);
    });

    const platformDeliveries = this.configurationServices.biclosecash_deliveries.filter(d => {
      if (!d.name) return false;
      const normalizedName = d.name.toLowerCase().trim();
      return !ownDeliveryNames.includes(normalizedName);
    });

    // Calcular ventas y ahorro de deliveries propios (bloque verde: Recogida + Domicilio)
    this.own_deliveries_total = ownDeliveries.reduce((sum, delivery) => {
      return sum + (delivery.total || 0);
    }, 0);
    this.own_deliveries_savings = this.own_deliveries_total * commissionRate;

    // Calcular ventas y ahorro potencial de plataformas (bloque rojo)
    this.platforms_deliveries_total = platformDeliveries.reduce((sum, delivery) => {
      return sum + (delivery.total || 0);
    }, 0);
    this.platforms_deliveries_savings = this.platforms_deliveries_total * commissionRate;

    // Mantener variables legacy para compatibilidad
    this.deliveries_total = this.platforms_deliveries_total;
    this.deliveries_with_commission = this.platforms_deliveries_savings;
    this.deliveries_savings = this.platforms_deliveries_savings;
    this.deliveries_savings_percentage = commissionRate * 100; // 25%
  }

  async getFoodcost() {
    var rs_foodcost_pb1 = document.getElementById('rs_foodcost_pb1');
    if (rs_foodcost_pb1) {
      rs_foodcost_pb1.style.display = 'none';
    }
    await this.http.post(this.globals.analytics_path + 'analytics/daily_report_foodcost', {
      public_key: this.globals.public_key,
      uid_cash: this.cash_uid,
      first_date: new Date(this.date_first),
      last_date: new Date(this.date_last),
    }, {}).subscribe(async data => {
      this.configurationServices.biclosecash_foodcost = data['foodcost'];
      this.configurationServices.biclosecash_benefit = data['benefit'];
      this.configurationServices.biclosecash_foodcost_percentage = data['foodcost_percentage'];
      this.foodcost_0_element = data['foodcost_0_element'];

      var rs_foodcost_pb1_1 = document.getElementById('rs_foodcost_pb1_1');
      var rs_foodcost_pb1_2 = document.getElementById('rs_foodcost_pb1_2');

      if (rs_foodcost_pb1_1 && rs_foodcost_pb1_2) {
        rs_foodcost_pb1_1.style.width = (100 - this.configurationServices.biclosecash_foodcost_percentage).toFixed(0) + '%';
        rs_foodcost_pb1_2.style.width = parseFloat(this.configurationServices.biclosecash_foodcost_percentage.toString()).toFixed(0) + '%';

        (document.getElementById('rs_foodcost_pb1_1') as HTMLInputElement).innerText = 'B ' + (100 - this.configurationServices.biclosecash_foodcost_percentage).toFixed(0) + '%';
        (document.getElementById('rs_foodcost_pb1_2') as HTMLInputElement).innerText = 'F ' + parseFloat(this.configurationServices.biclosecash_foodcost_percentage.toString()).toFixed(0) + '%';

        rs_foodcost_pb1.style.display = 'flex';
      }
      //loader
      this.loader_report_foodcost = false;
    },
      err => {
        this.loader_report_foodcost = false;
      });
  }

  //funcion que devuelve el listado de tickets cancelados
  async getTicketsCanceled() {
    this.loader_tickets_canceled_list = true;
    await this.http.post(this.globals.analytics_path + 'analytics/daily_report_tickets_canceled', {
      public_key: this.globals.public_key,
      uid_cash: this.cash_uid,
      first_date: moment(this.date_first).format('YYYY-MM-DD' + ' 00:00:00'),
      last_date: moment(this.date_last).format('YYYY-MM-DD' + ' 23:59:59'),
    }, {}).subscribe(async data => {

      this.configurationServices.biclosecash_tickets_canceled = data['list'];

      for (let ticket of data['list']) {
        ticket.DATE = new Date(ticket.DATE);
      }
      this.loader_tickets_canceled_list = false;
    },
      err => {
        this.loader_tickets_canceled_list = false;
      });
  }

  //funcion que devuelve las valoraciones
  public ratings_positive;
  public ratings_negative;
  async getRatings() {
    this.ratings_positive = undefined;
    this.ratings_negative = undefined;
    this.configurationServices.biclosecash_total_ratings_positive = undefined;
    try {
      const data: any = await this.http.post(this.globals.analytics_path + 'biclosecash/get_ratings', {
        public_key: this.globals.public_key,
        datetime_init: moment(this.date_first).format('YYYY-MM-DD' + ' 00:00:00'),
        datetime_final: moment(this.date_last).format('YYYY-MM-DD' + ' 23:59:59'),
      }).toPromise();
      this.ratings_positive = data['ratings_positive'];
      this.ratings_negative = data['ratings_negative'];

      this.configurationServices.biclosecash_total_ratings_positive = this.globals.regla3(data['ratings'], data['ratings_positive']);
      this.configurationServices.biclosecash_total_ratings_negative = this.globals.regla3(data['ratings'], data['ratings_negative']);
      this.configurationServices.biclosecash_total_ratings = data['ratings'];
    } catch (err) { }
  }

  // #region CHARTS

  //funcion que inicia la chart de top elements sold
  initChartTopElementSold(data) {
    this.chartTopElementsLabels = data['labels'];
    this.chartTopElementsData = data['data'];



    this.chartTopElementsType = 'bar';
    this.chartTopElementsOptions = {
      legend: {
        display: false,
        position: 'bottom',
      },
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      }
    };
    this.chartTopElementsColors = [
      {
        // grey
        backgroundColor: [
          '#e69500',
          'orange',
          '#fdbc44',
          '#fdca6b',
          '#fbd58f'
        ],
        borderColor: 'transparent',
        pointBackgroundColor: 'orange',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)'
      }
    ];
    this.loader_top_elements_sold = false;
  }

  //funcion que inicia la chart de top elements sold
  initChartTopCategoriesSold(data) {
    this.chartTopCategoriesLabels = data['labels'];
    this.chartTopCategoriesData = data['data'];
    this.chartTopCategoriesType = 'bar';
    this.chartTopCategoriesOptions = {
      legend: {
        display: false,
        position: 'bottom',
      },
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      }
    };
    this.chartTopCategoriesColors = [
      {
        // grey
        backgroundColor: [
          '#F8CFA9',
          '#FFB673',
          '#F8AD6D',
          '#FF7500',
          '#D76B00',
          '#BE5400',
          '#9D4815',
          '#EFD19F',
          '#EFBE7D',
          '#ECA154',
        ],
        borderColor: 'transparent',
        pointBackgroundColor: 'orange',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)'
      }
    ];
    this.loader_top_categories = false;
  }

  //funcion que inicia la chart de sales type
  initChartTicketType(data) {
    //funcion que formata y llena los campos de la grafica
    this.orderSalesType(data);
    //init conf
    this.chartTypeTicketType = 'horizontalBar';
    this.chartTypeTicketOptions = {
      legend: {
        display: false,
        position: 'bottom',
      },
      maintainAspectRatio: false,
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      }
    };
    this.chartTypeTicketcolors = [
      {
        // grey
        backgroundColor: [
          'orange',
          '#fdbc44',
          '#fdca6b',
          '#fbd58f'
        ],
        borderColor: 'transparent',
        pointBackgroundColor: 'orange',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)'
      }
    ];
  }

  //funcion que inicia la chart de payment type
  initChartPaymentType(data) {
    this.chartPaymentTypeLabels = [];
    this.chartPaymentTypeData = [];
    //
    if (data.total_cash > 0) {
      this.chartPaymentTypeLabels.push(this.translate.instant('general-efectivo'));
      this.chartPaymentTypeData.push(data.total_cash.toFixed(2));
    }
    if (data.total_card > 0) {
      this.chartPaymentTypeLabels.push(this.translate.instant('general-tarjeta'));
      this.chartPaymentTypeData.push(data.total_card.toFixed(2));
    }
    if (data.total_stripe > 0) {
      this.chartPaymentTypeLabels.push(this.translate.instant('general-tarjeta-online'));
      this.chartPaymentTypeData.push(data.total_stripe.toFixed(2));
    }
    if (data.total_paypal > 0) {
      this.chartPaymentTypeLabels.push('Paypal');
      this.chartPaymentTypeData.push(data.total_paypal.toFixed(2));
    }
    if (data.total_payplaza > 0) {
      this.chartPaymentTypeLabels.push('CM.com');
      this.chartPaymentTypeData.push(data.total_payplaza.toFixed(2));
    }
    if (data.total_verifone > 0) {
      this.chartPaymentTypeLabels.push('Verifone');
      this.chartPaymentTypeData.push(data.total_verifone.toFixed(2));
    }
    if (data.total_btc > 0) {
      this.chartPaymentTypeLabels.push('Bitcoin');
      this.chartPaymentTypeData.push(data.total_btc.toFixed(2));
    }
    if (data.total_bch > 0) {
      this.chartPaymentTypeLabels.push('Bitcoin Cash');
      this.chartPaymentTypeData.push(data.total_bch.toFixed(2));
    }
    if (data.total_dai > 0) {
      this.chartPaymentTypeLabels.push('Dai');
      this.chartPaymentTypeData.push(data.total_dai.toFixed(2));
    }
    if (data.total_doge > 0) {
      this.chartPaymentTypeLabels.push('Dogecoin');
      this.chartPaymentTypeData.push(data.total_doge.toFixed(2));
    }
    if (data.total_eth > 0) {
      this.chartPaymentTypeLabels.push('Ethereum');
      this.chartPaymentTypeData.push(data.total_eth.toFixed(2));
    }
    if (data.total_ltc > 0) {
      this.chartPaymentTypeLabels.push('Litecoin');
      this.chartPaymentTypeData.push(data.total_ltc.toFixed(2));
    }
    if (data.total_usdc > 0) {
      this.chartPaymentTypeLabels.push('USD Coin');
      this.chartPaymentTypeData.push(data.total_usdc.toFixed(2));
    }
    if (data.total_redsys > 0) {
      this.chartPaymentTypeLabels.push('Redsys');
      this.chartPaymentTypeData.push(data.total_redsys.toFixed(2));
    }
    if (data.total_getnet > 0) {
      this.chartPaymentTypeLabels.push('Getnet by Santander');
      this.chartPaymentTypeData.push(data.total_getnet.toFixed(2));
    }
    if (data.total_comerciaglobalpay > 0) {
      this.chartPaymentTypeLabels.push('CaixaBank');
      this.chartPaymentTypeData.push(data.total_comerciaglobalpay.toFixed(2));
    }
    if (data.total_bank_transfer > 0) {
      this.chartPaymentTypeLabels.push(this.translate.instant('general-bank-transfer'));
      this.chartPaymentTypeData.push(data.total_bank_transfer.toFixed(2));
    }
    if (data.total_american_express > 0) {
      this.chartPaymentTypeLabels.push(this.translate.instant('general-american-express'));
      this.chartPaymentTypeData.push(data.total_american_express.toFixed(2));
    }
    if (data.total_bizum > 0) {
      this.chartPaymentTypeLabels.push('Bizum');
      this.chartPaymentTypeData.push(data.total_bizum.toFixed(2));
    }
    if (data.total_online > 0) {
      this.chartPaymentTypeLabels.push('Online');
      this.chartPaymentTypeData.push(data.total_online.toFixed(2));
    }
    if (data.total_bank_draft > 0) {
      this.chartPaymentTypeLabels.push(this.translate.instant('general-bank-draft'));
      this.chartPaymentTypeData.push(data.total_bank_draft.toFixed(2));
    }
    if (data.total_cryptocurrencies > 0) {
      this.chartPaymentTypeLabels.push(this.translate.instant('pay-cryptomonedas'));
      this.chartPaymentTypeData.push(data.total_cryptocurrencies.toFixed(2));
    }
    if (data.total_ticket_restaurant > 0) {
      this.chartPaymentTypeLabels.push(this.translate.instant('general-ticket-restaurant'));
      this.chartPaymentTypeData.push(data.total_ticket_restaurant.toFixed(2));
    }
    if (data.total_not_specified > 0) {
      this.chartPaymentTypeLabels.push(this.translate.instant('general-no-especifico'));
      this.chartPaymentTypeData.push(data.total_not_specified.toFixed(2));
    }
    // Combinar los arrays en un array de objetos
    let combined = this.chartPaymentTypeLabels.map((label, index) => {
      return { label: label, data: this.chartPaymentTypeData[index] };
    });
    // Ordenar el array combinado de mayor a menor basado en el valor de data
    combined.sort((a, b) => b.data - a.data);
    // Separar los arrays ordenados
    this.chartPaymentTypeLabels = combined.map(item => item.label);
    this.chartPaymentTypeData = combined.map(item => item.data);
    // Montar chart
    this.chartPaymentTypeType = 'horizontalBar';
    this.chartPaymentTypeOptions = {
      legend: {
        display: false,
        position: 'top',
      },
      maintainAspectRatio: false,
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      }
    };

    this.chartPaymentTypeColors = [
      {
        // grey
        backgroundColor: [
          '#ffac14',
          '#ffb327',
          '#ffba3b',
          '#ffc14e',
          '#ffc862',
          '#ffcf76',
          '#ffd589',
          '#ffdc9d',
          '#ffe3b1',
          '#ffeac4',
          '#fff1d8',
          '#fff8eb'
        ],
        borderColor: 'transparent',
        pointBackgroundColor: 'orange',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)'
      }
    ];
  }

  //funcion que inicia la chart de discount type
  initChartDiscountType(data) {
    this.chartDiscountLabels = [this.translate.instant('general-descuento'), this.translate.instant('general-invitados'), this.translate.instant('general-ticket-r'), this.translate.instant('general-descuento-linea')];
    this.chartDiscountData = [this.globals.round2decimal(data.total_discount), this.globals.round2decimal(data.total_invite), this.globals.round2decimal(data.total_restaurant_ticket), this.globals.round2decimal(data.total_line_discount)];
    this.chartDiscountType = 'pie';
    this.chartDiscountOptions = {
      legend: {
        display: true,
        position: 'left',
      }
    };
    this.chartDiscountColors = [
      {
        // grey
        backgroundColor: [
          'orange',
          '#fdbc44',
          '#fdca6b',
          '#fbd58f',
          '#fce3b5'
        ],
        borderColor: 'transparent',
        pointBackgroundColor: 'orange',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)'
      }
    ];
  }


  // #region FUNCIONES


  async getCashs() {
    this.cashs = await this.configurationServices.getAllCashs(this.globals.restaurant_uid);
  }

  async cleanBiclosecashVars() {
    //loaders
    this.loader_totals = true;
    this.loader_report_totals = true;
    this.loader_payment_type = true;
    this.loader_tickets_list = true;
    this.loader_tickets_canceled_list = true;
    this.loader_history_cash = true;
    this.loader_history_close_cash = true;
    this.loader_top_elements_sold = true;
    this.loader_top_categories = true;
    this.loader_sales_type = true;
    this.loader_waiters_work_list = true;
    this.loader_discounts_type = true;
    this.loader_deliveries_type = true;
    this.loader_report_foodcost = true;
    //vars
    this.configurationServices.biclosecash_total_notax = 0;
    this.configurationServices.biclosecash_total = 0;
    this.configurationServices.biclosecash_total_tax = 0;
    this.configurationServices.biclosecash_sales_type_name = [];
    this.configurationServices.biclosecash_sales_type_amount = [];
    this.configurationServices.biclosecash_total_cash = 0;
    this.configurationServices.biclosecash_total_card = 0;
    this.configurationServices.biclosecash_total_not_specified = 0;
    this.configurationServices.biclosecash_waiters = [];
    this.configurationServices.biclosecash_tickets = [];
    this.configurationServices.biclosecash_tickets_canceled = [];
    this.configurationServices.biclosecash_total_tips = 0;
    this.configurationServices.biclosecash_total_discounted = 0;
    this.configurationServices.biclosecash_deliveries = [];
    this.configurationServices.biclosecash_history = [];
    this.configurationServices.biclosecash_arqueo = 0;
  }

  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('general-informe-de-ventas'),
      cashs: this.cashs,
      uid_cash: this.uid_cash,
      date_first: this.date_first,
      date_last: this.date_last,
      cash_bool: true,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        //
        this.cash_uid = data.cash_uid;
        this.uid_cash = data.uid_cash
        this.configurationServices.biclosecash_cash_name = data.cash_name;
        //
        this.date_first = data.date_first;
        this.date_last = data.date_last;
        //
        this.getAllDataOfCloseCash();
      }
    });
    profileModal.present();
  }

  openTicket(ticket) {
    if (ticket.CANCELLED) {
      if (ticket.uid_tickettimeline) {
        this.navCtrl.push(ConfigurationTicketsListPage, {
          state: 'closed',
          ticket: ticket,
          close_cash: 'true'
        });
      }
    } else {
      this.navCtrl.push(ConfigurationTicketsListPage, {
        state: 'closed',
        ticket: ticket,
        close_cash: 'true'
      });
    }
  }

  openInOutCash() {
    this.opened_page = 'entrada_salida_caja';
    this.navCtrl.push(TpvCashInoutCreatePage, {
      update_state: true
    });
  }

  openAnalytics() {
    this.globals.side_menu_active = 'informes';
    this.navCtrl.push(AnalyticsPage);


  }

  //funcion que monta los datos a nuestro gusto
  orderSalesType(data) {
    var array_type = [];
    var array_amount = [];
    data.sales_type_name.forEach((value, index) => {
      //'delivery', 'table', 'bar'
      if (value == 'table') {
        array_type[0] = this.translate.instant('general-mesa');
        array_amount[0] = data.sales_type_amount[index];
      } else if (value == 'bar') {
        array_type[1] = this.translate.instant('general-bar');
        array_amount[1] = data.sales_type_amount[index];
      } else {
        array_type[2] = this.translate.instant('general-delivery');
        array_amount[2] = data.sales_type_amount[index];
      }
    });
    //
    this.chartTypeTicketLabels = array_type;
    this.chartTypeTicketData = array_amount;
  }

  //funcion que convierte la fecha que viene de node a normal
  changeStringToDate() {
    var _date = new Date();
    if (this.configurationServices.biclosecash_history) {
      for (let item of this.configurationServices.biclosecash_history) {
        if (item.date.seconds) {
          _date = new Date(item.date.seconds * 1000);
        } else {
          _date = new Date(item.date._seconds * 1000);
        }
        var _date_f = moment(_date).format('YYYY/MM/DD HH:mm:ss');
        item.date = _date_f;
      }
    }
  }

  //calcula el arqueo de caja/cajas
  calculateArqueo() {
    var total = this.configurationServices.biclosecash_total_cash;
    var _incomingCash = 0;
    var _outgoingCash = 0;
    if (this.configurationServices.biclosecash_history) {
      for (let history of this.configurationServices.biclosecash_history) {
        if (history.type == 'in') {
          total += parseFloat(history.amount);
          _incomingCash += parseFloat(history.amount);
        } else {
          total -= parseFloat(history.amount);
          _outgoingCash += parseFloat(history.amount);
        }
      }
    }
    this.configurationServices.biclosecash_arqueo = total;
    this.configurationServices.biclosecash_total_incoming_cash = _incomingCash;
    this.configurationServices.biclosecash_total_outgoing_cash = _outgoingCash;
  }

  //funcion que apunta a api y crea/descarga un pdf del historial
  async downloadCloseCashHistory(type) {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    //
    var url_by_type = "";
    var url_of_server = "";
    if (type === 'pdf') {
      this.configurationServices.biclosecash_tickets = this.formatDate(this.configurationServices.biclosecash_tickets);
      this.configurationServices.biclosecash_tickets_canceled = this.formatDate(this.configurationServices.biclosecash_tickets_canceled);
      url_of_server = this.globals.api_path;
      url_by_type = "close_cash_new/download_pdf";
    } else {//excel
      url_of_server = this.globals.analytics_path;
      url_by_type = "close_cash_new/download_excel";
    }
    //
    this.configurationServices.biclosecash_historial_name = this.datepipe.transform(this.date_first, "dd-MM-yyyy HH:mm:ss") + ' - ' + this.datepipe.transform(this.date_last, "dd-MM-yyyy HH:mm:ss");
    this.configurationServices.biclosecash_historial_created = new Date();
    //prepare data to send
    var currency = getCurrencySymbol(this.globals.user_currency, 'narrow', 'es');
    //send api
    this.http.post(url_of_server + url_by_type,
      {
        public_key: this.globals.public_key,
        uid_rest_subs: this.globals.apiUidRestaurant(),
        total_notax: this.configurationServices.biclosecash_total_notax,
        total_tax: this.configurationServices.biclosecash_total_tax,
        total_taxes: JSON.stringify(this.configurationServices.biclosecash_total_taxes),
        total: this.configurationServices.biclosecash_total,
        total_cash: this.configurationServices.biclosecash_total_cash,
        total_card: this.configurationServices.biclosecash_total_card,
        total_not_specified: this.configurationServices.biclosecash_total_not_specified,
        total_stripe: this.configurationServices.biclosecash_total_stripe,
        total_paypal: this.configurationServices.biclosecash_total_paypal,
        total_payplaza: this.configurationServices.biclosecash_total_payplaza,
        total_verifone: this.configurationServices.biclosecash_total_verifone,
        total_btc: this.configurationServices.biclosecash_total_btc,
        total_bch: this.configurationServices.biclosecash_total_bch,
        total_dai: this.configurationServices.biclosecash_total_dai,
        total_doge: this.configurationServices.biclosecash_total_doge,
        total_eth: this.configurationServices.biclosecash_total_eth,
        total_ltc: this.configurationServices.biclosecash_total_ltc,
        total_usdc: this.configurationServices.biclosecash_total_usdc,
        total_redsys: this.configurationServices.biclosecash_total_redsys,
        total_getnet: this.configurationServices.biclosecash_total_getnet,
        total_comerciaglobalpay: this.configurationServices.biclosecash_total_comerciaglobalpay,
        total_bank_transfer: this.configurationServices.biclosecash_total_bank_transfer,
        total_american_express: this.configurationServices.biclosecash_total_american_express,
        total_bizum: this.configurationServices.biclosecash_total_bizum,
        total_online: this.configurationServices.biclosecash_total_online,
        total_bank_draft: this.configurationServices.biclosecash_total_bank_draft,
        total_cryptocurrencies: this.configurationServices.biclosecash_total_cryptocurrencies,
        total_ticket_restaurant: this.configurationServices.biclosecash_total_ticket_restaurant,
        history: JSON.stringify(this.configurationServices.biclosecash_history),
        total_discount: this.configurationServices.biclosecash_total_discount,
        total_invite: this.configurationServices.biclosecash_total_invite,
        total_restaurant_ticket: this.configurationServices.biclosecash_total_restaurant_ticket,
        total_line_discount: this.configurationServices.biclosecash_total_line_discount,
        total_tips: this.configurationServices.biclosecash_total_tips,
        historial_tickets: JSON.stringify(this.configurationServices.biclosecash_tickets),
        historial_tickets_canceled: JSON.stringify(this.configurationServices.biclosecash_tickets_canceled),
        currency: currency,
        company: this.globals.restaurant.company,
        periodo: this.configurationServices.biclosecash_historial_name,
        cash_name: this.configurationServices.biclosecash_cash_name,
        arqueo: this.configurationServices.biclosecash_arqueo,
        created_cc: this.datepipe.transform(this.configurationServices.biclosecash_historial_created, "dd-MM-yyyy HH:mm:ss"),
      }
      , {})
      .subscribe(res => {
        if (this.globals.so_mobile) {
          window.location.assign(String(res['file']));
        } else {
          window.open(String(res['file']), '_blank');
        }
        loadingPopup.dismiss();
      }, error => {
        loadingPopup.dismiss();
      });
  }

  //funcion que imprime el historial
  printCloseCashHistory(type) {
    this.configurationServices.biclosecash_historial_name = this.datepipe.transform(this.date_first, "dd-MM-yyyy HH:ss:mm") + ' - ' + this.datepipe.transform(this.date_last, "dd-MM-yyyy HH:ss:mm");
    this.configurationServices.biclosecash_historial_created = new Date();
    //
    if (this.globals.restaurant.printer_type == 'native') {
      this.globals.print_content = document.getElementById(type);
      let loadingPopup = this.loadingCtrl.create({
        spinner: 'crescent',
        content: this.translate.instant('instant-imprimiendo')
      });
      loadingPopup.present();
      var interval = setInterval(() => {
        this.printServices.printNow(type);
        loadingPopup.dismiss();
        clearInterval(interval);
      }, 1000);

    } else {
      this.printServices.prepareNewCloseCash(this.globals.restaurant.printer_type, 'new', type);
    }
  }

  //
  trFontColor(ticket) {
    if (ticket.refund && ticket.amount < 0) {
      let cssClasses = {
        'text-danger': true,
      };
      return cssClasses;
    }
    return '';
  }

  //
  openWaiterInfo(waiter) {
    let profileModal = this.modalCtrl.create(PopupWaiterReportSales, {
      waiter: waiter,
    });
    profileModal.onDidDismiss(data => {
    });
    profileModal.present();
  }

  formatDate(tickets) {
    for (let ticket of tickets) {
      if (ticket.date) {
        ticket.format_date = this.globals.timestampToDateWithFormat(ticket.date, 'DD/MM/YYYY HH:mm:ss');
      } else {
        ticket.format_date = this.globals.timestampToDateWithFormat(ticket.DATETIME, 'DD/MM/YYYY HH:mm:ss');
      }
    }
    return tickets;
  }

  clickElement(event) {
    if (event.type == 'click') {
      if (event.row.CANCELLED) {
        if (event.row.uid_tickettimeline) {
          this.navCtrl.push(ConfigurationTicketsListPage, {
            state: 'closed',
            ticket: event.row,
            close_cash: 'true'
          });
        }
      } else {
        this.navCtrl.push(ConfigurationTicketsListPage, {
          state: 'closed',
          ticket: event.row,
          close_cash: 'true'
        });
      }
    }
  }

  onSort(event) {
    var tickets_array = this.configurationServices.biclosecash_tickets_array_tmp;

    switch (event.column.name) {
      case 'number':
        if (event.newValue == 'asc') {
          tickets_array.sort((a, b) => a.number - b.number);
        } else {
          tickets_array.sort((a, b) => b.number - a.number);
        }
        break;
      case 'date':
        if (event.newValue == 'asc') {
          tickets_array.sort((a, b) => this.globals.timestampToDate(a.date).localeCompare(this.globals.timestampToDate(b.date)));
        } else {
          tickets_array.sort((a, b) => this.globals.timestampToDate(b.date).localeCompare(this.globals.timestampToDate(a.date)));
        }
        break;
      case 'cash_static':
        if (event.newValue == 'asc') {
          tickets_array.sort((a, b) => a.cash_static.localeCompare(b.cash_static));
        } else {
          tickets_array.sort((a, b) => b.cash_static.localeCompare(a.cash_static));
        }
        break;
      case 'type':
        if (event.newValue == 'asc') {
          tickets_array.sort((a, b) => a.type.localeCompare(b.type));
        } else {
          tickets_array.sort((a, b) => b.type.localeCompare(a.type));
        }
        break;
      case 'payment_type':
        if (event.newValue == 'asc') {
          tickets_array.sort((a, b) => a.payment_type.localeCompare(b.payment_type));
        } else {
          tickets_array.sort((a, b) => b.payment_type.localeCompare(a.payment_type));
        }
        break;
      case 'amount':
        if (event.newValue == 'asc') {
          tickets_array.sort((a, b) => a.amount - b.amount);
        } else {
          tickets_array.sort((a, b) => b.amount - a.amount);
        }
        break;
    }

    this.configurationServices.biclosecash_tickets_array_tmp = tickets_array;
  }

  onSortInOut(event) {
    var history_array = this.configurationServices.biclosecash_history;

    switch (event.column.name) {
      case 'cash':
        if (event.newValue == 'asc') {
          history_array.sort((a, b) => a.cash.localeCompare(b.cash));
        } else {
          history_array.sort((a, b) => b.cash.localeCompare(a.cash));
        }
        break;
      case 'type':
        if (event.newValue == 'asc') {
          history_array.sort((a, b) => a.type.localeCompare(b.type));
        } else {
          history_array.sort((a, b) => b.type.localeCompare(a.type));
        }
        break;
      case 'date_final':
        if (event.newValue == 'asc') {
          history_array.sort((a, b) => a.date_final.localeCompare(b.date_final));
        } else {
          history_array.sort((a, b) => b.date_final.localeCompare(a.date_final));
        }
        break;
      case 'concept':
        if (event.newValue == 'asc') {
          history_array.sort((a, b) => a.concept.localeCompare(b.concept));
        } else {
          history_array.sort((a, b) => b.concept.localeCompare(a.concept));
        }
        break;
      case 'amount':
        if (event.newValue == 'asc') {
          history_array.sort((a, b) => a.amount - b.amount);
        } else {
          history_array.sort((a, b) => b.amount - a.amount);
        }
        break;
    }
    this.configurationServices.biclosecash_history = history_array;
  }

  ticketsSearch(value) {
    if (value) {
      this.configurationServices.biclosecash_tickets_filtered = this.configurationServices.biclosecash_list_tickets_array.filter(objeto => {
        return this.globals.objectToArray(objeto).some(valor => {
          if (typeof valor === 'string' || typeof valor === 'number') {
            // Comparar como string
            return valor.toString().toLowerCase().includes(value.toLowerCase());
          } else if (Array.isArray(valor)) {
            // Buscar en cada elemento del array
            return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
          }
          return false;
        });
      });
    } else {
      this.configurationServices.biclosecash_tickets_filtered = this.configurationServices.biclosecash_list_tickets_array;
    }
  }

  createCloseCashHistory() {
    //prepare data
    this.configurationServices.biclosecash_historial_name = this.datepipe.transform(this.date_first, "dd-MM-yyyy HH:ss:mm") + ' - ' + this.datepipe.transform(this.date_last, "dd-MM-yyyy HH:ss:mm");
    //push
    this.navCtrl.push(ConfigurationCloseCashCreate, {
      action: 'create'
    });
  }

  openCloseCashList() {
    this.navCtrl.push(ConfigurationCloseCashList);
  }

  openCustomerList() {
    this.navCtrl.push(CustomersListPage);
  }

  openRatingsList() {
    this.navCtrl.push(ConfigurationTicketsRatingsListPage);
  }

  styleIcon(total) {
    let styles = {
      'width': total + '%',
    };
    return styles;
  }
}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-close-cash/configuration-close-cash-view/configuration-close-cash-view.ts